import style from './ExtraPaymentType.module.scss';
import { IExtraPaymentType } from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import React from 'react';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IProps {
	extraPaymentType: IExtraPaymentType;
}

const ExtraPaymentType: React.FC<IProps> = ({ extraPaymentType }) => {
	return (
		<div className={style.container}>
			<FullInfoField label="paymentTypeIdLabel" value={extraPaymentType.paymentTypeId} />
			<FullInfoField label="cardBrandLabel" value={extraPaymentType.brand} />
		</div>
	);
};

export default React.memo(ExtraPaymentType);
